import { EButtonStyleType, EButtonHoverType } from '@common/enums';

import { ThemeFontTags } from '../enums/font-tags.enum';

/**
 * The fixed lists the settings panels iterate: which tags, which button styles, which hover kinds.
 *
 * Each of these was a field on whichever component happened to need it, so the same decision — the
 * order tags appear in, which two button styles a theme has — was restated in two or three places.
 */

/** The order the font panel and the preset strip list tags in. `h2` and `p` lead: they are what a user changes. */
export const FONT_TAGS_ORDER = [
    ThemeFontTags.h2,
    ThemeFontTags.p,
    ThemeFontTags.button,
    ThemeFontTags.h1,
    ThemeFontTags.h3,
    ThemeFontTags.h4,
    ThemeFontTags.leading,
    ThemeFontTags.big,
    ThemeFontTags.small,
    ThemeFontTags.quote,
    ThemeFontTags.signature,
    ThemeFontTags.pre,
] as const;

/**
 * Tags the panel styles but never shows a row for.
 *
 * `pre` follows body copy rather than being edited on its own — the font settings form copies `p`'s
 * family onto it before saving.
 */
export const HIDDEN_FONT_TAGS = [ThemeFontTags.pre] as const;

/** A theme has exactly these two button styles. */
export const THEME_BUTTON_STYLE_TYPES = [EButtonStyleType.primary, EButtonStyleType.secondary] as const;

/** The hover kinds the button editor's dropdown offers. */
export const BUTTON_HOVER_TYPE_OPTIONS = [
    { label: 'control_hover_effect_option_opacity', value: EButtonHoverType.opacity },
    { label: 'control_hover_effect_option_shadow', value: EButtonHoverType.shadow },
    { label: 'control_hover_effect_option_color', value: EButtonHoverType.color },
] as const;
